import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';

import type { Recipe } from '@/api/types';
import Markdown from '@/modules/component/Markdown';
import { markdownBody } from '@/modules/component/Markdown/style';

import { styles } from './style';

interface RecipeItemProps {
    recipe: Recipe;
}

// The first child of Accordion is the summary, the rest go into the collapsible region
const RecipeItem = ({ recipe }: RecipeItemProps) => (
    <Accordion sx={styles.accordion}>
        <AccordionSummary expandIcon={<ExpandMoreIcon/>} sx={styles.summary}>
            <Typography component="span">{recipe.title}</Typography>
        </AccordionSummary>
        <AccordionDetails sx={styles.details}>
            <Typography component="div" align="left" sx={markdownBody}>
                <Markdown>{recipe.description}</Markdown>
            </Typography>
        </AccordionDetails>
        <Typography component="div" align="right" color="text.secondary">
            <Markdown>{recipe.resources ?? ''}</Markdown>
        </Typography>
    </Accordion>
);

export default RecipeItem;
